import dayjs from "dayjs";
import { zSidLabel } from "src/types";
import { zMdmFile } from "src/types/ZMdmFile";

import { ZAttrMeta, ZTypeDef } from "../ZAttrMeta";
import { ZAttrValueListRaw, ZAttrValueRecord } from "../ZAttrValue";

// default не используется чтобы при добавлении новых типов здесь возникла ошибка компиляции
/* eslint consistent-return: "off" */
/* eslint default-case: "off" */

export const attrValueRawToInternal = (
  value: unknown,
  type: ZTypeDef,
): unknown => {
  switch (type.name) {
    case "string":
      if (typeof value === "string") return value;
      if (typeof value === "boolean" || typeof value === "number") {
        return JSON.stringify(value);
      }
      if (typeof value === "object") {
        // Это конечно неочевидный момент, но поможет в случае смены типа strOption на string
        const res = zSidLabel.safeParse(value);
        if (res.success) return res.data.id;
      }
      return null;
    case "number":
      if (typeof value === "number") {
        return value;
      }
      if (typeof value === "string") {
        const s = +value;
        return Number.isNaN(s) ? null : s;
      }
      if (value === true) return 1;
      if (value === false) return 0;
      return null;
    case "boolean":
      if (value === false || value === "false" || value === 0) return false;
      if (value === true || value === "true" || value === 1) return true;
      return null;
    case "dateTime":
      if (typeof value === "string" && value) {
        if (dayjs(value).isValid()) return value;
      }
      return null;
    case "strOption":
      if (typeof value === "object" && value) {
        const res = zSidLabel.safeParse(value);
        if (res.success) return res.data;
      }
      return null;
    case "file":
      if (typeof value === "object" && value) {
        const res = zMdmFile.safeParse(value);
        if (res.success) return res.data;
      }
      return null;
    case "list":
      if (Array.isArray(value) && type.fields) {
        return cvtList(value, type.fields);
      }
      return null;
    case "array":
      if (Array.isArray(value) && type.item) {
        const itemType = type.item.type;
        return value.map((itemValue) =>
          attrValueRawToInternal(itemValue, itemType),
        );
      }
      return null;
  }
};

const cvtList = (list: unknown[], fields: ZAttrMeta[]): ZAttrValueListRaw => {
  const result: ZAttrValueListRaw = {};
  list.forEach((record, index) => {
    if (record && typeof record === "object") {
      result[String(index)] = attrsRecordRawToInternal(
        record as ZAttrValueRecord,
        fields,
      );
    }
  });
  return result;
};

export const attrsRecordRawToInternal = (
  values: ZAttrValueRecord,
  fields: ZAttrMeta[],
): ZAttrValueRecord => {
  const result: ZAttrValueRecord = {};
  fields.forEach((field) => {
    result[field.name] = attrValueRawToInternal(values[field.name], field.type);
  });
  return result;
};
